import { EN_TENANT_NAME } from '../../enums/tenant';
import { registerPlugin } from '../../plugins/plugin_register';
import { DefaultRegistry } from '../default_registry';
import { registerTenantConfig } from '../register';

@registerTenantConfig(EN_TENANT_NAME.上海电气)
export class 上海电气TenantRegistry extends DefaultRegistry {
  static async register(): Promise<void> {
    // super.register();
    const { UIConfig3 } = await import(
      '../../plugins/service_plugins/ui_config/ui_config_sh_electric'
    );
    registerPlugin(UIConfig3);
  }
}
